/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\FooterLiStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 15th 2023, 4:48:33 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const FooterLiStyled = styled.li.attrs(props => ({
    bgColor: props.bgColor,
}))`
width: fit-content;
list-style: none;
padding: 0.4rem;
color: white;
text-align: center;
&:hover{
    text-decoration: underline ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
}
& > a,
a:visited {
    color:var(--white);
}
`;

export default FooterLiStyled;
